import { z } from '@harvestiq/zod';
import {
  dbLrpEndorsementSchema,
  dbLrpEndorsementInsertSchema,
} from './db-lrp-endorsement';
import {
  dbLgmEndorsementSchema,
  dbLgmEndorsementInsertSchema,
} from './db-lgm-endorsement';

export const createLrpCoverageRequestSchema = dbLrpEndorsementInsertSchema
  .pick({
    type: true,
    typeCode: true,
    details: true,
    agentSignedAt: true,
    commodityCode: true,
    createdBy: true,
    customerSignedAt: true,
    externalStatus: true,
    isExternallyManaged: true,
    policyId: true,
    entityHistoryId: true,
    salesEffectiveDate: true,
    endDate: true,
    status: true,
    submittedToAipAt: true,
    watchedAt: true,
    coverageLevel: true,
    signingAgentId: true, // the PDF signing agent
    insuredSharePercent: true,
    isPre2026BeginningFarmerRancher: true,
    isVeteranFarmerRancher: true,
    beginningFarmerRancherCropYearCount: true,
  })
  // API Endpoint specific fields
  .extend({
    coverageOwnerId: z.string().nullable().optional(), // @note kept for backward compatibility @todo remove once FF is removed
    sendAgentNotification: z.boolean(),
    sendCustomerNotification: z.boolean(),
  })
  // Optional fields that are given default value by API if not provided
  .partial({
    createdBy: true,
    coverageLevel: true,
    // TODO: Remove once callers are updated to pass insuredSharePercent
    insuredSharePercent: true,
  });
export type CreateLrpCoverageRequest = z.infer<
  typeof createLrpCoverageRequestSchema
>;

export const createLgmCoverageRequestSchema = dbLgmEndorsementInsertSchema
  .pick({
    type: true,
    typeCode: true,
    details: true,
    agentSignedAt: true,
    commodityCode: true,
    createdBy: true,
    customerSignedAt: true,
    externalStatus: true,
    isExternallyManaged: true,
    policyId: true,
    entityHistoryId: true,
    salesEffectiveDate: true,
    status: true,
    submittedToAipAt: true,
    watchedAt: true,
    liveCattleTargetCwtPerHead: true,
    feederCattleTargetCwtPerHead: true,
    cornTargetBuPerHead: true,
    signingAgentId: true, // the PDF signing agent
    isPre2026BeginningFarmerRancher: true,
    isVeteranFarmerRancher: true,
    beginningFarmerRancherCropYearCount: true,
  })
  // API Endpoint specific fields
  .extend({
    coverageOwnerId: z.string().nullable().optional(), // @note kept for backward compatibility @todo remove once FF is removed
    sendAgentNotification: z.boolean(),
    sendCustomerNotification: z.boolean(),
  })
  // Optional fields that are given default value by API if not provided
  .partial({
    createdBy: true,
  });
export type CreateLgmCoverageRequest = z.infer<
  typeof createLgmCoverageRequestSchema
>;

export const createCoverageRequestSchema = z.discriminatedUnion('type', [
  createLrpCoverageRequestSchema,
  createLgmCoverageRequestSchema,
]);
export type CreateCoverageRequest = z.infer<typeof createCoverageRequestSchema>;

export const createLrpCoverageResponseSchema = z.object({
  coverage: dbLrpEndorsementSchema,
  filename: z.string().nullable().optional(),
});

export type CreateLrpCoverageResponse = z.infer<
  typeof createLrpCoverageResponseSchema
>;

export const createLgmCoverageResponseSchema = z.object({
  coverage: dbLgmEndorsementSchema,
  filename: z.string().nullable().optional(),
});

export type CreateLgmCoverageResponse = z.infer<
  typeof createLgmCoverageResponseSchema
>;
